var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.286,
    height: 71.286,
    viewBox: "0 0 71.286 71.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600",
    transform: "translate(-926 -3854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money-Donation",
    transform: "translate(926 3854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M8.463,37.314v4.1A1.366,1.366,0,0,1,7.1,42.777H4.366a1.366,1.366,0,1,1,0-2.731H5.731V12.731H4.366a1.366,1.366,0,1,1,0-2.731H7.1a1.366,1.366,0,0,1,1.366,1.366v3.749l4.359-3.57a6.82,6.82,0,0,1,6.925-1.028l7.166,2.959C31.237,15.358,32.8,18.4,31.1,22.09a5.451,5.451,0,0,1-1.375,1.884l4.327,1.376,15.388-7.826c3.164-1.432,5.717-1.2,7.23.963,1.873,2.678.838,5.4-1.79,7.839-1.084,1.008-8.243,6.446-18.957,14.5a6.82,6.82,0,0,1-5.962,1.109L13.7,37.314Zm0-2.731h5.432l.373.052,16.443,4.672a4.092,4.092,0,0,0,3.577-.665C44.826,30.72,52.053,25.231,53.026,24.325c1.754-1.631,2.284-3.024,1.412-4.272-.621-.888-1.768-.992-3.813-.068L34.794,28.039a1.364,1.364,0,0,1-1.032.084L23.6,24.891a20.062,20.062,0,0,1-2.964-.942l-1.682-.535a1.367,1.367,0,0,1-.792-1.942q.021-.058.048-.116a1.364,1.364,0,0,1,1.817-.652q.775.366,1.475.654l3.013.958c2.2.433,3.512-.073,4.109-1.369.995-2.161.229-3.648-2.778-4.958l-7.142-2.949a4.092,4.092,0,0,0-4.155.617L8.463,18.645Z",
    transform: "translate(5.194 17.314)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M22.194,5.731h3.969A1.366,1.366,0,0,1,27.529,7.1V8.131a1.366,1.366,0,0,1-2.691.332h-6.7A1.366,1.366,0,0,0,16.77,9.829V11.2a1.366,1.366,0,0,0,1.366,1.366H23.56a4.1,4.1,0,0,1,4.1,4.1v1.364a4.1,4.1,0,0,1-4.1,4.1H22.194v1.342a1.366,1.366,0,1,1-2.731,0V22.12h-4.1A1.366,1.366,0,0,1,14,20.713l.038-1.252a1.366,1.366,0,0,1,2.726-.072h6.8a1.366,1.366,0,0,0,1.366-1.366V16.659a1.366,1.366,0,0,0-1.366-1.366H18.135a4.1,4.1,0,0,1-4.1-4.1V9.829a4.1,4.1,0,0,1,4.1-4.1h1.328V4.366a1.366,1.366,0,1,1,2.731,0Z",
    transform: "translate(24.24 5.194)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Money-Donation-2",
    "data-name": "Money-Donation",
    transform: "translate(929 3857)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M8.463,37.314v4.1A1.366,1.366,0,0,1,7.1,42.777H4.366a1.366,1.366,0,1,1,0-2.731H5.731V12.731H4.366a1.366,1.366,0,1,1,0-2.731H7.1a1.366,1.366,0,0,1,1.366,1.366v3.749l4.359-3.57a6.82,6.82,0,0,1,6.925-1.028l7.166,2.959C31.237,15.358,32.8,18.4,31.1,22.09a5.451,5.451,0,0,1-1.375,1.884l4.327,1.376,15.388-7.826c3.164-1.432,5.717-1.2,7.23.963,1.873,2.678.838,5.4-1.79,7.839-1.084,1.008-8.243,6.446-18.957,14.5a6.82,6.82,0,0,1-5.962,1.109L13.7,37.314Z",
    transform: "translate(5.194 17.314)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    d: "M22.194,5.731h3.969A1.366,1.366,0,0,1,27.529,7.1V8.131a1.366,1.366,0,0,1-2.691.332h-6.7A1.366,1.366,0,0,0,16.77,9.829V11.2a1.366,1.366,0,0,0,1.366,1.366H23.56a4.1,4.1,0,0,1,4.1,4.1v1.364a4.1,4.1,0,0,1-4.1,4.1H22.194v1.342a1.366,1.366,0,1,1-2.731,0V22.12h-4.1A1.366,1.366,0,0,1,14,20.713l.038-1.252a1.366,1.366,0,0,1,2.726-.072h6.8a1.366,1.366,0,0,0,1.366-1.366V16.659a1.366,1.366,0,0,0-1.366-1.366H18.135a4.1,4.1,0,0,1-4.1-4.1V9.829a4.1,4.1,0,0,1,4.1-4.1h1.328V4.366a1.366,1.366,0,1,1,2.731,0Z",
    transform: "translate(24.24 5.194)",
    fill: "#fe9920"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.39ffd7717480b8f059e9d7a3f9c4116d.svg";
export { ForwardRef as ReactComponent };